module.exports = __webpack_public_path__ + "static/iracing-hero-897361c0544de285ec464c4ed86b6807.mp4";